//broadcast/send
//post
export function sendBroadcast() {
    return {
        success: true,
        msg: 'Test notification sent successfully',
        data: {
            userId: 'user_123456',
            recipientName: 'Jane Doe',
            successCount: 10,
            failureCount: 2,
            invalidTokensRemoved: 1,
        },
    }
}

//broadcast/history?page=1&limit=10
//get
export function getBroadcastHistory() {
    return {
        "success": true,
        "data": [],
        "pagination": {
            "page": 1,
            "limit": 10,
            "total": 0,
            "totalPages": 0
        },
        "sender": {
            "_id": "61442a17a6566a001623bf20",
            "displayName": "Jeffrey Pareja",
            "firstName": "Jeffrey",
            "lastName": "Pareja",
            "company": "Sparkle Star International - Inhouse",
            "email": "jeffreypareja25@gmail.com"
        }
    }
}
